/**
 * Constantes del Sistema de Suscripciones
 * Definiciones estándar para estados, frecuencias y configuraciones
 */

/**
 * Estados de suscripción
 */
export const SUBSCRIPTION_STATUS = {
  PENDING: 'pending',
  AUTHORIZED: 'authorized',
  PAUSED: 'paused',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
  CHARGED_BACK: 'charged_back'
};

/**
 * Display names para estados de suscripción
 */
export const SUBSCRIPTION_STATUS_DISPLAY = {
  [SUBSCRIPTION_STATUS.PENDING]: 'Pendiente',
  [SUBSCRIPTION_STATUS.AUTHORIZED]: 'Activa',
  [SUBSCRIPTION_STATUS.PAUSED]: 'Pausada',
  [SUBSCRIPTION_STATUS.CANCELLED]: 'Cancelada',
  [SUBSCRIPTION_STATUS.EXPIRED]: 'Expirada',
  [SUBSCRIPTION_STATUS.CHARGED_BACK]: 'Contracargada'
};

/**
 * Colores para estados de suscripción
 */
export const SUBSCRIPTION_STATUS_COLORS = {
  [SUBSCRIPTION_STATUS.PENDING]: {
    bg: 'bg-yellow-50',
    border: 'border-yellow-200',
    text: 'text-yellow-800',
    icon: '⏳'
  },
  [SUBSCRIPTION_STATUS.AUTHORIZED]: {
    bg: 'bg-green-50',
    border: 'border-green-200',
    text: 'text-green-800',
    icon: '✅'
  },
  [SUBSCRIPTION_STATUS.PAUSED]: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-800',
    icon: '⏸️'
  },
  [SUBSCRIPTION_STATUS.CANCELLED]: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-800',
    icon: '❌'
  },
  [SUBSCRIPTION_STATUS.EXPIRED]: {
    bg: 'bg-gray-50',
    border: 'border-gray-200',
    text: 'text-gray-800',
    icon: '⏰'
  },
  [SUBSCRIPTION_STATUS.CHARGED_BACK]: {
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    text: 'text-purple-800',
    icon: '🔄'
  }
};

/**
 * Frecuencias de suscripción
 */
export const SUBSCRIPTION_FREQUENCY = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  BIWEEKLY: 'biweekly',
  MONTHLY: 'monthly',
  BIMONTHLY: 'bimonthly',
  QUARTERLY: 'quarterly',
  SEMIANNUALLY: 'semiannually',
  YEARLY: 'yearly'
};

/**
 * Display names para frecuencias
 */
export const SUBSCRIPTION_FREQUENCY_DISPLAY = {
  [SUBSCRIPTION_FREQUENCY.DAILY]: 'Diario',
  [SUBSCRIPTION_FREQUENCY.WEEKLY]: 'Semanal',
  [SUBSCRIPTION_FREQUENCY.BIWEEKLY]: 'Quincenal',
  [SUBSCRIPTION_FREQUENCY.MONTHLY]: 'Mensual',
  [SUBSCRIPTION_FREQUENCY.BIMONTHLY]: 'Bimensual',
  [SUBSCRIPTION_FREQUENCY.QUARTERLY]: 'Trimestral',
  [SUBSCRIPTION_FREQUENCY.SEMIANNUALLY]: 'Semestral',
  [SUBSCRIPTION_FREQUENCY.YEARLY]: 'Anual'
};

/**
 * Estados de pago
 */
export const PAYMENT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  AUTHORIZED: 'authorized',
  IN_PROCESS: 'in_process',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  CHARGED_BACK: 'charged_back'
};

/**
 * Display names para estados de pago
 */
export const PAYMENT_STATUS_DISPLAY = {
  [PAYMENT_STATUS.PENDING]: 'Pendiente',
  [PAYMENT_STATUS.APPROVED]: 'Aprobado',
  [PAYMENT_STATUS.AUTHORIZED]: 'Autorizado',
  [PAYMENT_STATUS.IN_PROCESS]: 'En proceso',
  [PAYMENT_STATUS.REJECTED]: 'Rechazado',
  [PAYMENT_STATUS.CANCELLED]: 'Cancelado',
  [PAYMENT_STATUS.REFUNDED]: 'Reembolsado',
  [PAYMENT_STATUS.CHARGED_BACK]: 'Contracargado'
};

/**
 * Colores para estados de pago
 */
export const PAYMENT_STATUS_COLORS = {
  [PAYMENT_STATUS.PENDING]: {
    bg: 'bg-yellow-50',
    border: 'border-yellow-200',
    text: 'text-yellow-800',
    icon: '⏳'
  },
  [PAYMENT_STATUS.APPROVED]: {
    bg: 'bg-green-50',
    border: 'border-green-200',
    text: 'text-green-800',
    icon: '✅'
  },
  [PAYMENT_STATUS.AUTHORIZED]: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-800',
    icon: '🔒'
  },
  [PAYMENT_STATUS.IN_PROCESS]: {
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-800',
    icon: '⚡'
  },
  [PAYMENT_STATUS.REJECTED]: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-800',
    icon: '❌'
  },
  [PAYMENT_STATUS.CANCELLED]: {
    bg: 'bg-gray-50',
    border: 'border-gray-200',
    text: 'text-gray-800',
    icon: '🚫'
  },
  [PAYMENT_STATUS.REFUNDED]: {
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    text: 'text-purple-800',
    icon: '💰'
  },
  [PAYMENT_STATUS.CHARGED_BACK]: {
    bg: 'bg-red-100',
    border: 'border-red-300',
    text: 'text-red-900',
    icon: '🔄'
  }
};

/**
 * Métodos de pago
 */
export const PAYMENT_METHODS = {
  CREDIT_CARD: 'credit_card',
  DEBIT_CARD: 'debit_card',
  TICKET: 'ticket',
  BANK_TRANSFER: 'bank_transfer',
  DIGITAL_WALLET: 'digital_wallet',
  CASH: 'cash'
};

/**
 * Display names para métodos de pago
 */
export const PAYMENT_METHODS_DISPLAY = {
  [PAYMENT_METHODS.CREDIT_CARD]: 'Tarjeta de Crédito',
  [PAYMENT_METHODS.DEBIT_CARD]: 'Tarjeta de Débito',
  [PAYMENT_METHODS.TICKET]: 'Boleto',
  [PAYMENT_METHODS.BANK_TRANSFER]: 'Transferencia Bancaria',
  [PAYMENT_METHODS.DIGITAL_WALLET]: 'Billetera Digital',
  [PAYMENT_METHODS.CASH]: 'Efectivo'
};

/**
 * Monedas soportadas
 */
export const SUPPORTED_CURRENCIES = {
  ARS: {
    name: 'Peso Argentino',
    symbol: '$',
    code: 'ARS',
    decimalPlaces: 2
  },
  BRL: {
    name: 'Real Brasileño',
    symbol: 'R$',
    code: 'BRL',
    decimalPlaces: 2
  },
  MXN: {
    name: 'Peso Mexicano',
    symbol: '$',
    code: 'MXN',
    decimalPlaces: 2
  },
  USD: {
    name: 'Dólar Americano',
    symbol: '$',
    code: 'USD',
    decimalPlaces: 2
  },
  EUR: {
    name: 'Euro',
    symbol: '€',
    code: 'EUR',
    decimalPlaces: 2
  }
};

/**
 * URLs de Mercado Pago
 */
export const MERCADO_PAGO_URLS = {
  SANDBOX: {
    BASE: 'https://sandbox.mercadopago.com',
    API: 'https://api.mercadopago.com',
    CHECKOUT: 'https://sandbox.mercadopago.com/checkout/v1/redirect'
  },
  PRODUCTION: {
    BASE: 'https://www.mercadopago.com',
    API: 'https://api.mercadopago.com',
    CHECKOUT: 'https://www.mercadopago.com/checkout/v1/redirect'
  }
};

/**
 * Límites y restricciones
 */
export const SUBSCRIPTION_LIMITS = {
  MIN_AMOUNT: {
    ARS: 1,
    BRL: 1,
    MXN: 1,
    USD: 1,
    EUR: 1
  },
  MAX_AMOUNT: {
    ARS: 50000,
    BRL: 50000,
    MXN: 50000,
    USD: 10000,
    EUR: 10000
  },
  MAX_DESCRIPTION_LENGTH: 255,
  MAX_REASON_LENGTH: 255,
  MAX_EXTERNAL_REFERENCE_LENGTH: 64
};

/**
 * Configuración de UI
 */
export const UI_CONFIG = {
  ANIMATIONS: {
    DURATION: {
      FAST: 150,
      NORMAL: 300,
      SLOW: 500
    },
    EASING: {
      EASE_IN: 'ease-in',
      EASE_OUT: 'ease-out',
      EASE_IN_OUT: 'ease-in-out'
    }
  },
  BREAKPOINTS: {
    SM: '640px',
    MD: '768px',
    LG: '1024px',
    XL: '1280px'
  },
  SPACING: {
    XS: '0.25rem',
    SM: '0.5rem',
    MD: '1rem',
    LG: '1.5rem',
    XL: '2rem'
  }
};

/**
 * Tipos de planes
 */
export const PLAN_TYPES = {
  FREE: 'free',
  BASIC: 'basic',
  PREMIUM: 'premium',
  PRO: 'pro',
  ENTERPRISE: 'enterprise'
};

/**
 * Display names para tipos de planes
 */
export const PLAN_TYPES_DISPLAY = {
  [PLAN_TYPES.FREE]: 'Gratis',
  [PLAN_TYPES.BASIC]: 'Básico',
  [PLAN_TYPES.PREMIUM]: 'Premium',
  [PLAN_TYPES.PRO]: 'Pro',
  [PLAN_TYPES.ENTERPRISE]: 'Empresarial'
};

/**
 * Características populares de planes
 */
export const POPULAR_FEATURES = {
  UNLIMITED_MATCHES: 'Matches ilimitados',
  ADVANCED_FILTERS: 'Filtros avanzados',
  INCognito_MODE: 'Modo incógnito',
  PROFILE_BOOSTS: 'Boosts de perfil',
  MESSAGE_READ_RECEIPTS: 'Confirmación de lectura',
  NO_ADS: 'Sin anuncios',
  PRIORITY_SUPPORT: 'Soporte prioritario',
  CUSTOM_PROFILE: 'Perfil personalizado',
  VIDEO_CALLS: 'Llamadas de video',
  GIFT_FEATURES: 'Funciones de regalos'
};

/**
 * Mensajes de error comunes
 */
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Error de conexión. Verifica tu internet.',
  PAYMENT_CANCELLED: 'El pago fue cancelado.',
  PAYMENT_DECLINED: 'El pago fue rechazado. Intenta con otro método.',
  SUBSCRIPTION_EXISTS: 'Ya tienes una suscripción activa.',
  PLAN_NOT_FOUND: 'El plan seleccionado no está disponible.',
  USER_NOT_AUTHENTICATED: 'Debes iniciar sesión para continuar.',
  INVALID_EMAIL: 'El email no es válido.',
  INVALID_AMOUNT: 'El monto no es válido.',
  SESSION_EXPIRED: 'Tu sesión ha expirado. Inicia sesión nuevamente.',
  GENERIC_ERROR: 'Ocurrió un error. Intenta nuevamente.'
};

/**
 * Mensajes de éxito
 */
export const SUCCESS_MESSAGES = {
  SUBSCRIPTION_CREATED: '¡Suscripción creada exitosamente!',
  PAYMENT_PROCESSED: 'Pago procesado correctamente.',
  SUBSCRIPTION_CANCELLED: 'Suscripción cancelada.',
  SUBSCRIPTION_PAUSED: 'Suscripción pausada.',
  SUBSCRIPTION_REACTIVATED: 'Suscripción reactivada.',
  PROFILE_UPDATED: 'Perfil actualizado.',
  PAYMENT_METHOD_UPDATED: 'Método de pago actualizado.'
};

/**
 * Eventos de webhook
 */
export const WEBHOOK_EVENTS = {
  PAYMENT_CREATED: 'payment.created',
  PAYMENT_UPDATED: 'payment.updated',
  SUBSCRIPTION_CREATED: 'subscription_preapproval.created',
  SUBSCRIPTION_UPDATED: 'subscription_preapproval.updated',
  SUBSCRIPTION_CANCELLED: 'subscription_preapproval.cancelled',
  SUBSCRIPTION_PAUSED: 'subscription_preapproval.paused',
  SUBSCRIPTION_REACTIVATED: 'subscription_preapproval.reactivated'
};

/**
 * Configuración de cache
 */
export const CACHE_CONFIG = {
  TTL: {
    PLANS: 10 * 60 * 1000, // 10 minutos
    USER_SUBSCRIPTION: 5 * 60 * 1000, // 5 minutos
    PAYMENT_METHODS: 30 * 60 * 1000, // 30 minutos
    USER_PROFILE: 15 * 60 * 1000 // 15 minutos
  },
  KEYS: {
    PLANS: 'app_plans',
    USER_SUBSCRIPTION: (userId) => `user_subscription_${userId}`,
    PAYMENT_METHODS: 'payment_methods',
    USER_PROFILE: (userId) => `user_profile_${userId}`
  }
};

export default {
  SUBSCRIPTION_STATUS,
  SUBSCRIPTION_STATUS_DISPLAY,
  SUBSCRIPTION_STATUS_COLORS,
  SUBSCRIPTION_FREQUENCY,
  SUBSCRIPTION_FREQUENCY_DISPLAY,
  PAYMENT_STATUS,
  PAYMENT_STATUS_DISPLAY,
  PAYMENT_STATUS_COLORS,
  PAYMENT_METHODS,
  PAYMENT_METHODS_DISPLAY,
  SUPPORTED_CURRENCIES,
  MERCADO_PAGO_URLS,
  SUBSCRIPTION_LIMITS,
  UI_CONFIG,
  PLAN_TYPES,
  PLAN_TYPES_DISPLAY,
  POPULAR_FEATURES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  WEBHOOK_EVENTS,
  CACHE_CONFIG
};
